__turbopack_context__.v({
  "allowlistInfo": "MintCountdownBox-module-scss-module__Ht3P9a__allowlistInfo",
  "countdownContainer": "MintCountdownBox-module-scss-module__Ht3P9a__countdownContainer",
  "countdownContainerShort": "MintCountdownBox-module-scss-module__Ht3P9a__countdownContainerShort",
  "mintBtn": "MintCountdownBox-module-scss-module__Ht3P9a__mintBtn",
  "shimmer": "MintCountdownBox-module-scss-module__Ht3P9a__shimmer",
  "skeletonBtn": "MintCountdownBox-module-scss-module__Ht3P9a__skeletonBtn",
});
